import { render, staticRenderFns } from "./CollezionamentoSlider.vue?vue&type=template&id=9130d7f2"
import script from "./CollezionamentoSlider.vue?vue&type=script&lang=js"
export * from "./CollezionamentoSlider.vue?vue&type=script&lang=js"
import style0 from "./CollezionamentoSlider.vue?vue&type=style&index=0&id=9130d7f2&prod&global=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports